import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a8da5770"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "search_container" }
const _hoisted_3 = { class: "search_box" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("新建")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("重置搜索")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("readme")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("配置")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("删除")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_TableLayout = _resolveComponent("TableLayout")!
  const _component_AdvertisementInformationDialog = _resolveComponent("AdvertisementInformationDialog")!
  const _component_AdvertisementItemDialog = _resolveComponent("AdvertisementItemDialog")!
  const _component_ReadmeDialog = _resolveComponent("ReadmeDialog")!
  const _component_MainLayout = _resolveComponent("MainLayout")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_MainLayout, null, {
    default: _withCtx(() => [
      _createVNode(_component_TableLayout, null, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_select, {
                modelValue: _ctx.searchHandle.type,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchHandle.type) = $event)),
                class: "search_input",
                placeholder: "请选择广告类型"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchHandle.typeList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_select, {
                modelValue: _ctx.searchHandle.client,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchHandle.client) = $event)),
                class: "search_input",
                placeholder: "请选择产品形态"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchHandle.clientList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_input, {
                modelValue: _ctx.searchHandle.position,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchHandle.position) = $event)),
                class: "search_input",
                placeholder: "广告位置"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_el_input, {
                modelValue: _ctx.searchHandle.ad_name,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchHandle.ad_name) = $event)),
                class: "search_input",
                placeholder: "广告名称"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                type: "warning",
                onClick: _ctx.newAdvertiseHandle.newAdvertisement
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.searchHandle.search
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "info",
                onClick: _ctx.searchHandle.reset
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_button, {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.clickReadmeDialogClose(true)))
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ])
          ])
        ]),
        main: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            height: "100%",
            border: "",
            data: _ctx.tableHandle.list,
            class: "table_box"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                width: "100",
                prop: "id",
                label: "广告id"
              }),
              _createVNode(_component_el_table_column, {
                "min-width": "350",
                prop: "ad_name",
                label: "广告位名称(广告的描述)"
              }),
              _createVNode(_component_el_table_column, {
                width: "100",
                label: "广告类型"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_ctx.AdTypeByLabelMap[scope.row.ad_type]), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                width: "100",
                label: "产品形态"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_ctx.ClientTypeByLabelMap[scope.row.client_type]), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                "min-width": "250",
                prop: "pos_code",
                label: "广告位置(接口调用的code)"
              }),
              _createVNode(_component_el_table_column, {
                width: "180",
                label: "创建时间"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_ctx.formatDate(new Date(scope.row.create_time), 'yyyy-MM-dd hh:mm:ss')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                width: "180",
                label: "更新时间"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_ctx.formatDate(new Date(scope.row.update_time), 'yyyy-MM-dd hh:mm:ss')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                "min-width": "60",
                label: "状态"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_ctx.StatusByLabelMap[scope.row.status]), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "操作",
                width: "300",
                fixed: "right"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "primary",
                    onClick: ($event: any) => (_ctx.tableHandle.edit(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "success",
                    onClick: ($event: any) => (_ctx.tableHandle.dispose(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  (scope.row.status === -1)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        size: "small",
                        type: "primary",
                        onClick: ($event: any) => (_ctx.tableHandle.start(scope.row))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (scope.row.status === 1)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        size: "small",
                        type: "danger",
                        onClick: ($event: any) => (_ctx.tableHandle.forbid(scope.row))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "danger",
                    onClick: ($event: any) => (_ctx.tableHandle.delete(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, _ctx.tableHandle.loading]
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_el_pagination, {
            align: "right",
            "current-page": _ctx.paginationHandle.page,
            "page-size": _ctx.paginationHandle.size,
            total: _ctx.paginationHandle.total,
            onSizeChange: _ctx.paginationHandle.handleSizeChange,
            onCurrentChange: _ctx.paginationHandle.handleCurrentChange
          }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
        ]),
        _: 1
      }),
      (_ctx.advertisementInformationDialogHandle.visible)
        ? (_openBlock(), _createBlock(_component_AdvertisementInformationDialog, {
            key: 0,
            id: _ctx.advertisementInformationDialogHandle.id,
            modelValue: _ctx.advertisementInformationDialogHandle.visible,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.advertisementInformationDialogHandle.visible) = $event)),
            onClickAdvertisementInformationDialogClose: _ctx.advertisementInformationDialogHandle.clickAdvertisementInformationDialogClose,
            onClickAdvertisementInformationDialogSubmit: _ctx.advertisementInformationDialogHandle.clickAdvertisementInformationDialogSubmit
          }, null, 8, ["id", "modelValue", "onClickAdvertisementInformationDialogClose", "onClickAdvertisementInformationDialogSubmit"]))
        : _createCommentVNode("", true),
      (_ctx.advertisementItemDialogHandle.visible)
        ? (_openBlock(), _createBlock(_component_AdvertisementItemDialog, {
            key: 1,
            modelValue: _ctx.advertisementItemDialogHandle.visible,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.advertisementItemDialogHandle.visible) = $event)),
            "ad-id": _ctx.advertisementItemDialogHandle.adId,
            type: _ctx.advertisementItemDialogHandle.type,
            onClickAdvertisementItemDialogClose: _ctx.advertisementItemDialogHandle.clickAdvertisementItemDialogClose
          }, null, 8, ["modelValue", "ad-id", "type", "onClickAdvertisementItemDialogClose"]))
        : _createCommentVNode("", true),
      _createVNode(_component_ReadmeDialog, {
        modelValue: _ctx.readmeDialogVisible,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.readmeDialogVisible) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }))
}